import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserStore } from '@/stores/useUserStore';

export default function RequireAuth() {
  const user = useUserStore((state) => state.user);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
